<template>
  <div id="page_index">
    <div class="banner">
      <img src="../assets/img/index_banner.jpg" alt="" class="bg">
      <wave3d class="wave3d"></wave3d>
      <div class="textbox">
        <h1 class="wow fadeInLeft">Acoustic Solution Provider<br />Of Sustainability And Innovation</h1>
        <p>Brotex is where technology, innovation and creativity converge, we aim to provide the best acoustic solution.
        </p>
      </div>
      <router-link to="./Product" class="mainBtn1 hbutton_isi">DISCOVER MORE</router-link>
    </div>
    <div id="part1" class="full">
      <div class="mainTitle1 textbox">
        <h3>Company Advantage</h3>
        <p>As a leader in acoustic design solutions, we offering an expansive library of sound absorption products and
          accessory options. </p>
      </div>
      <div class="itembox">
        <div class="item wow flipInY" data-wow-delay=".1s">
          <img src="../assets/img/index_part1bg.png" alt="" class="bg">
          <img src="../assets/img/index_part1icon1.png" alt="" class="icon">
          <h4>Focused On Research & Development</h4>
          <p>Brotex Technologies is always pushing the boundaries to implement new products & ideas.</p>
        </div>
        <div class="item wow flipInY" data-wow-delay=".2s">
          <img src="../assets/img/index_part1bg.png" alt="" class="bg">
          <img src="../assets/img/index_part1icon2.png" alt="" class="icon">
          <h4>Our Value</h4>
          <p>At the heart of Brotex are our guiding values of Integrity, Respect, Collaboration, Excellence, and
            Leadership. These values support us as we deliver on our vision to be the top.</p>
        </div>
        <div class="item wow flipInY" data-wow-delay=".3s">
          <img src="../assets/img/index_part1bg.png" alt="" class="bg">
          <img src="../assets/img/index_part1icon3.png" alt="" class="icon">
          <h4>After Service</h4>
          <p>Brotex wins the markets as the value of “Customer Comes First” with long-term friendly cooperation. We aim to
            provide you with a high standard after service, customer satisfaction is our goal.</p>
        </div>
        <div class="item wow flipInY" data-wow-delay=".4s">
          <img src="../assets/img/index_part1bg.png" alt="" class="bg">
          <img src="../assets/img/index_part1icon4.png" alt="" class="icon">
          <h4>Leaders In Eco-Friendly Materials</h4>
          <p>Brotex is the leading sustainable product that fits within all projects and can supply its products to
            projects and job sites globally.</p>
        </div>
      </div>
    </div>
    <div id="part2">
      <div class="titlebox">
        <div class="mainTitle1 textbox">
          <h3>Main Categories</h3>
          <p>View our product catalog to get an acoustic rundown of our products and get what you want.</p>
        </div>
        <router-link to="./Product" class="mainBtn1 hbutton_isi">DISCOVER MORE</router-link>
      </div>
      <div class="itembox">
        <router-link :to="{ path: './Product', query: { cin: index } }" class="item wow fadeIn"
          :data-wow-delay="`${(index + 1) / 10}`" v-for="(item, index) in catList" :key="index">
          <img :src="`${$https}${item.img}`" alt="">
          <p>{{ item.name }}</p>
        </router-link>
      </div>
    </div>
    <div id="part3" class="full">
      <div class="bgcover"></div>
      <div class="bgbox" :style="{ backgroundImage: `url(${swp1List[swp1Index].bg})` }"></div>
      <div class="mainTitle1 textbox white">
        <h3>Applications For Acoustic Panels</h3>
        <p>Acoustics product applies to the environmental-demanding places.It shows the high grade public image and create
          a warm business entertainment and office atmosphere.</p>
      </div>
      <router-link to="./Application" class="mainBtn1 hbutton_isi">DISCOVER MORE</router-link>
      <div class="contentbox">
        <div class="tab_header">
          <div class="item" :class="index == swp1Index ? 'active' : ''" v-for="(item, index) in swp1List" :key="index"
            @click="swp1Index = index">{{ item.title }}</div>
        </div>
        <div class="tab_content">
          <img :src="swp1List[swp1Index].img" alt="" class="leftimg">
          <div class="textbox">
            <div class="line">
              <img :src="swp1List[swp1Index].icon" alt="">
              <h4>{{ swp1List[swp1Index].title }}</h4>
            </div>
            <p>{{ swp1List[swp1Index].text }}</p>
          </div>
        </div>
      </div>
    </div>
    <div id="part4" class="full">
      <div class="mainTitle1 textbox">
        <h3>Service And Tech</h3>
      </div>
      <div class="contentbox">
        <div class="left">
          <p v-for="(item, index) in tabList[tabIndex].text" :key="index">{{ item }}</p>
          <router-link to="./Service" class="mainBtn1 hbutton_isi">DISCOVER MORE</router-link>
        </div>
        <div class="right">
          <div class="item" :class="index == tabIndex ? 'active' : ''" v-for="(item, index) in tabList" :key="index"
            @click="tabIndex = index">{{ item.title }}</div>
          <div class="line"></div>
        </div>
      </div>
    </div>
    <div id="part5">
      <div class="mainTitle1 textbox">
        <h3>Hot Sales</h3>
        <p>Check our star products, we make design happen.</p>
      </div>
      <div class="contentbox">
        <swiper class="swiper2 swiper-no-swiping" ref="swiper2" :options="swp2opt" :auto-update='true'>
          <swiper-slide v-for="(item, index) in hotList" :key="index">
            <router-link class="item" :to="{ path: './ProductInfo', query: { id: item.id } }" target="_blank">
              <div class="imgbox">
                <i class="triangle-topleft"></i>
                <img :src="`${$https}${item.img}`" alt="">
                <i class="triangle-topright"></i>
                <div class="cover"></div>
              </div>
              <p>{{ item.name }}</p>
              <div class="mainBtn2"><span>LEARN MORE</span><i>></i></div>
            </router-link>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev sbp2" slot="button-prev"></div>
        <div class="swiper-button-next sbn2" slot="button-next"></div>
      </div>
    </div>
    <div class="slogan">
      <h2>Welcome to ask for a question on improving your project visually and acoustically.</h2>
      <router-link to="./Contact" class="mainBtn1 hbutton_isi">CONTACT US</router-link>
    </div>
    <div id="part6">
      <div class="left">
        <div class="mainTitle1 textbox">
          <h3>About Brotex</h3>
          <p>Brotex is a leader in acoustic design solutions, offering an expansive library of sound absorption products
            and accessory options. These utilize our sustainably sourced, 100% recyclable, lightweight and durable
            high-performance material. Brotex comes with a wide range of colors and finishes, including wood textures,
            with available customization, to help you achieve the look you need while you build noise reduction into your
            spaces.</p>
        </div>
        <router-link to="./Company" class="mainBtn1 hbutton_isi">DISCOVER MORE</router-link>
        <div class="countbox">
          <div class="item" v-for="(item, index) in countList" :key="index">
            <countTo class="num" :startVal='item.start' :endVal='item.end' :duration='2000' separator=""></countTo>
            <p>{{ item.text }}</p>
          </div>
        </div>
      </div>
      <img class="right" src="../assets/img/index_part6img.jpg" alt="">
    </div>
    <!-- <div id="part7" class="full">
      <wave3d3 class="wave3d"></wave3d3>
      <div class="left">
        <div class="mainTitle1 textbox white">
          <h3>Our Certification</h3>
          <p>Certificates can not only prove our strength but also bring customers security and trust.In particular,
            Brotex's superior acoustic panels, ultra-microporous sound-absorbing panels, have obtained multiple
            certifications. With its high-quality aperture advantages and design, a Helmholtz resonance system is formed.
            The characteristics of high resistance and low perforation make the ultrasonic absorption coefficient of this
            series particularly excellent, reaching the top level in the industry.</p>
          <p>We are confident to manufacture more high-quality certified products so that you can buy and use them with
            certifications.</p>
        </div>
      </div>
      <div class="right">
        <swiper class="swiper3" ref="swiper3" :options="swp3opt" :auto-update='true'>
          <swiper-slide>
            <img src="../assets/img/首页-证书1.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/首页-证书2.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/首页-证书3.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/首页证书4.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/certificate1.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/certificate2.jpg" alt="">
          </swiper-slide>
          <swiper-slide>
            <img src="../assets/img/certificate3.jpg" alt="">
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev sbp3" slot="button-prev"></div>
        <div class="swiper-button-next sbn3" slot="button-next"></div>
      </div>
    </div> -->
    <div id="part8">
      <div class="titlebox">
        <div class="mainTitle1 textbox">
          <h3>Fresh News</h3>
          <p>Want to learn more about Brotex and the field of acoustics?Click to get them!</p>
        </div>
        <router-link to="./News" class="mainBtn1 hbutton_isi">DISCOVER MORE</router-link>
      </div>
      <div class="itembox">
        <router-link :to="{ path: './NewsInfo', query: { id: item.id } }" class="item" v-for="(item, index) in newsList"
          :key="index" target="_blank">
          <img :src="`${$https}${item.articleImg}`" alt="">
          <h4>{{ item.name }}</h4>
          <div class="bottom">
            <span>{{ item.timelist }}</span>
            <i>></i>
          </div>
        </router-link>
      </div>
    </div>
    <div id="comment" class="full">
      <div class="mainTitle1 textbox">
        <h3>Trusted By Our Customers</h3>
        <p>Let our customers to personally explain the use of our services and products.</p>
      </div>
      <div class="itembox">
        <swiper class="swiper1" ref="swipercom" :options="commentopt" :auto-update='true'>
          <swiper-slide class="item" v-for="(item, index) in list" :key="index">
            <div class="imgbox">
              <img :src="item.img" alt="" class="head">
              <img src="../assets/img/comment_icon.png" alt="" class="icon">
            </div>
            <el-rate class="rate" v-model="rate" disabled></el-rate>
            <p>{{ item.text }}</p>
            <span>{{ item.name }}</span>
          </swiper-slide>
        </swiper>
        <div class="swiper-button-prev sbp2" slot="button-prev"></div>
        <div class="swiper-button-next sbn2" slot="button-next" ref="swpcomnext"></div>
        <!--      <div class="item" v-for="(item,index) in list" :key="index">-->
        <!--        <div class="imgbox">-->
        <!--          <img :src="item.img" alt="" class="head">-->
        <!--          <img src="../assets/img/comment_icon.png" alt="" class="icon">-->
        <!--        </div>-->
        <!--        <el-rate class="rate" v-model="rate" disabled></el-rate>-->
        <!--        <p>{{item.text}}</p>-->
        <!--        <span>{{item.name}}</span>-->
        <!--      </div>-->
      </div>
    </div>
  </div>
</template>

<script>
import { WOW } from 'wowjs'
import * as $request from "../api/index";
// import comment from "../components/comment";
import wave3d from "../components/wave3d";
// import wave3d3 from "../components/wave3d3";
import countTo from 'vue-count-to';
export default {
  name: "Index",
  metaInfo: {
    title: 'Guangdong Brotex Acoustic Technology Co.,Ltd | Home',
  },
  components: {
    // comment,
    wave3d,
    // wave3d3,
    countTo,
  },
  data() {
    return {
      rate: 5,
      list: [
        {
          img: require('../assets/img/comment_img1.jpg'),
          name: 'Laura , the United States',
          text: 'Since installing Brotex products, the sonic difference has been really astounding in our concert hall. It was a really great auditory experience.',
        },
        {
          img: require('../assets/img/comment_img2.jpg'),
          name: 'Ella , HK of China',
          text: 'We are delighted to work with Brotex Acoustics. Their products and expertise have allowed us to set up one of our studios very quickly and with great results. ',
        },
        {
          img: require('../assets/img/comment_img3.jpg'),
          name: 'Jimmy , UAE',
          text: 'The perforated acoustic panels of Brotex are really good materials and look. They clean up all the extra reverb in the room, and we didn\'t need to fill the whole room with them.',
        },
        {
          img: require('../assets/img/comment_img4.jpg'),
          name: 'Peter , the United States',
          text: 'Our panels arrived on time without any delay. Thank you very much for completing such a large order perfectly. Looking forward to our next cooperation!',
        },
      ],
      commentopt: {
        slidesPerView: 3,
        spaceBetween: 30,
        slidesPerColumnFill: 'row',
        navigation: {
          nextEl: '.sbn2',
          prevEl: '.sbp2'
        },
      },
      catList: [
        {
          id: 0,
          img: require('../assets/img/index_part2img1.jpg'),
          name: 'Perforated Acoustic Panel',
        },
        {
          id: 0,
          img: require('../assets/img/index_part2img2.jpg'),
          name: 'Grooved Acoustic Panel',
        },
        {
          id: 0,
          img: require('../assets/img/index_part2img3.jpg'),
          name: 'Wood Wool Acoustic Panel',
        },
        {
          id: 0,
          img: require('../assets/img/index_part2img4.jpg'),
          name: 'Fabric Acoustic Panel',
        },
        {
          id: 0,
          img: require('../assets/img/index_part2img5.jpg'),
          name: 'Metal Acoustic Panel',
        },
        {
          id: 0,
          img: require('../assets/img/index_part2img6.jpg'),
          name: 'Art Acoustic Panel',
        },
        {
          id: 0,
          img: require('../assets/img/index_part2img7.jpg'),
          name: 'Melamine Acoustic Foam',
        },
      ],
      swp1Index: 0,
      swp1List: [
        {
          bg: require('../assets/img/application_bg1.jpg'),
          title: 'Office',
          text: 'Brotex develops different strategies for various challenges and develops personalized configurations to optimize problem-solving based on the function and design of the office space. ',
          icon: require('../assets/img/index_part3icon1.png'),
          img: require('../assets/img/office2.jpg'),
        },
        {
          bg: require('../assets/img/application_bg2.jpg'),
          title: 'School',
          text: 'Brotex has a great number of successfully completed projects, both in purposed and multifunctional halls, which you can see here. For further information get in touch for a consultation with our specialists.',
          icon: require('../assets/img/index_part3icon2.png'),
          img: require('../assets/img/school4.jpg'),
        },
        {
          bg: require('../assets/img/application_bg3.jpg'),
          title: 'Auditorium',
          text: 'Brotex provides acoustic solutions for auditorium, including dedicated halls and multi-function auditorium, to provide you with the best sound quality.',
          icon: require('../assets/img/index_part3icon3.png'),
          img: require('../assets/img/theater1.jpg'),
        },
        {
          bg: require('../assets/img/application_bg4.jpg'),
          title: 'Commercial',
          text: 'Brotex is an expert in permanently solving noise problems. There are different professional methods for reducing noise on the walls and ceilings of commercial places. ',
          icon: require('../assets/img/index_part3icon4.png'),
          img: require('../assets/img/hall1.jpg'),
        },
        {
          bg: require('../assets/img/application_bg5.jpg'),
          title: 'Indoor Stadium',
          text: 'Brotex provides many successful cases for indoor stadiums and gymnasiums, for further information, click and learn more.',
          icon: require('../assets/img/index_part3icon5.png'),
          img: require('../assets/img/indoor1.jpg'),
        },
        // {
        //   bg:require('../assets/img/application_bg2.jpg'),
        //   title:'Cinema',
        //   text:'Brotex designs active and passive noise control systems for the cinema space. If you need to provide solutions for your cinema, you can contact us.',
        //   icon:require('../assets/img/index_part3icon1.png'),
        //   img:require('../assets/img/cinema1.jpg'),
        // },
      ],
      tabIndex: 0,
      tabList: [
        {
          title: 'Technology',
          text: [
            'Creativity, expert knowledge, and cutting-edge technology shape everything we do—whether it’s exploring form and function in our growing range of acoustic products, adapting our customized solution to meet project needs.',
            'Our team is fully committed to preserving your project\'s core intent and bringing your vision to life.combining cutting-edge technology and software with a deep understanding of design to push the boundaries of acoustics.',
          ],
        },
        {
          title: 'After Sale',
          text: [
            'Creativity, expert knowledge, and cutting-edge technology shape everything we do—whether it’s exploring form and function in our growing range of acoustic products, adapting our customized solution to meet project needs.',
            'Our team is fully committed to preserving your project\'s core intent and bringing your vision to life.combining cutting-edge technology and software with a deep understanding of design to push the boundaries of acoustics.',
          ],
        },
        {
          title: 'Customization',
          text: [
            'Creativity, expert knowledge, and cutting-edge technology shape everything we do—whether it’s exploring form and function in our growing range of acoustic products, adapting our customized solution to meet project needs.',
            'Our team is fully committed to preserving your project\'s core intent and bringing your vision to life.combining cutting-edge technology and software with a deep understanding of design to push the boundaries of acoustics.',
          ],
        },
      ],
      hotList: [
        {
          id: 0,
          img: require('../assets/img/index_hotimg1.jpg'),
          name: '1Perforated Acoustic Panel',
        },
        {
          id: 0,
          img: require('../assets/img/index_hotimg1.jpg'),
          name: '2Perforated Acoustic Panel',
        },
        {
          id: 0,
          img: require('../assets/img/index_hotimg1.jpg'),
          name: '3Perforated Acoustic Panel',
        },
        {
          id: 0,
          img: require('../assets/img/index_hotimg1.jpg'),
          name: '4Perforated Acoustic Panel',
        },
        {
          id: 0,
          img: require('../assets/img/index_hotimg1.jpg'),
          name: '5Perforated Acoustic Panel',
        },
        {
          id: 0,
          img: require('../assets/img/index_hotimg1.jpg'),
          name: '6Perforated Acoustic Panel',
        },
      ],
      swp2opt: {
        slidesPerView: 3,
        slidesPerColumn: 2,
        spaceBetween: 25,
        slidesPerColumnFill: 'row',
        navigation: {
          nextEl: '.sbn2',
          prevEl: '.sbp2'
        },
      },
      swp3opt: {
        slidesPerView: 3,
        slidesPerColumn: 1,
        // spaceBetween: 25,
        slidesPerColumnFill: 'row',
        navigation: {
          nextEl: '.sbn3',
          prevEl: '.sbp3'
        },
      },
      countList: [
        // {
        //   start:0,
        //   end:0,
        //   text:'Every space engages and impacts',
        // },
        // {
        //   start:0,
        //   end:0,
        //   text:'Every space engages and impacts',
        // },
        // {
        //   start:0,
        //   end:0,
        //   text:'Factory Area',
        // },
      ],
      newsList: [
        {
          id: 0,
          img: require('../assets/img/index_part8img.jpg'),
          name: 'Want to learn more about Brotex and the field of acoustics?',
          time: '30 July  2020',
        },
        {
          id: 0,
          img: require('../assets/img/index_part8img.jpg'),
          name: 'Want to learn more about Brotex and the field of acoustics?',
          time: '30 July  2020',
        },
        {
          id: 0,
          img: require('../assets/img/index_part8img.jpg'),
          name: 'Want to learn more about Brotex and the field of acoustics?',
          time: '30 July  2020',
        },
      ],
    }
  },
  created() {
    this.$emit('getnav', 0)
    $request.getCats().then(res => {
      res.forEach(val => {
        if (val.name == 'en') {
          this.catList = val.sonList
          // console.log(this.catList)
        }
      })
    })
    $request.gethotShops().then(res => {
      this.hotList = res
      // console.log(this.hotList)
    })
    $request.getnews(1, 3).then(res => {
      this.newsList = res.datas
      this.newsList.forEach(val => {
        val.timelist = this.$date(val.releaseDate)
      })
      console.log(this.newsList)
    })
  },
  mounted() {
    this.$nextTick(() => {
      let wow = new WOW({
        live: false
      })
      wow.init()
      let flag = true
      window.onscroll = () => {
        //变量scrollTop是滚动条滚动时，距离顶部的距离
        var scrollTopo = document.documentElement.scrollTop || document.body.scrollTop;
        //变量windowHeight是可视区的高度
        // var windowHeight = document.documentElement.clientHeight || document.body.clientHeight;
        //变量scrollHeight是滚动条的总高度
        // var scrollHeight = document.documentElement.scrollHeight || document.body.scrollHeight;
        //滚动条到底部的条件
        // console.log(scrollTopo)
        if (scrollTopo > 5200 && flag == true) {
          // this.countList[0].end = 2000;
          // this.countList[1].end = 1996;
          // this.countList[2].end = 2000;
          // this.countList[3].end = 6;
          setTimeout(() => {
            this.$refs.swpcomnext.removeAttribute('class', 'swiper-button-disabled')
            this.$refs.swpcomnext.setAttribute('class', 'swiper-button-next sbn2')
            // console.log(this.$refs.swpcomnext.classList);
          }, 200)
          flag = false
        }
      };
    })
  }
}
</script>

<style lang="less" scoped>
#page_index {
  .banner {
    background: linear-gradient(to right, @main-c1 0%, @main-c1 3%, @main-c4 3%, @main-c4 100%);
    height: 918px;
    position: relative;
    z-index: 1;
    padding: 280px 0 0 280px;

    .bg {
      position: absolute;
      bottom: 0;
      right: 0;
      border-radius: 100px 0 0 0;
      z-index: -1;
    }

    .wave3d {
      position: absolute;
      left: 3%;
      bottom: 0;
      width: 50%;
      height: 50%;
      z-index: -2;
    }

    .textbox {
      h1 {
        color: white;
      }

      p {
        font: 22px/34px Poppins-Regular;
        color: white;
        width: 50%;
        margin: 70px 0 100px;
      }
    }
  }

  #part1 {
    background: @main-c3;

    .itembox {
      .item {
        position: relative;
        width: calc(25% - 25px);
        display: flex;
        flex-direction: column;
        align-items: center;
        color: @main-c2;
        background: white;
        padding: 60px 0 45px;
        z-index: 1;

        .bg {
          position: absolute;
          top: 50%;
          left: 50%;
          transform: translate(-50%, -50%);
          z-index: -1
        }

        h4 {
          text-align: center;
          margin: 20px 0;
        }

        p {
          font: 15px/24px Poppins-Regular;
          width: 90%;
          margin: 0 auto;
        }

        &:hover {
          background: @main-c1;
        }
      }
    }
  }

  #part2 {
    .titlebox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 70px;

      .mainTitle1 {
        margin-bottom: 0;

        h3:before {
          left: -5.5%;
        }

        p {
          width: 60%;
        }
      }
    }

    .itembox {
      justify-content: center;
      flex-wrap: wrap;

      .item {
        width: calc(25% - 40px);
        text-align: center;
        margin: 0 20px 40px;

        img {
          width: 100%;
          height: 295px;
          object-fit: cover;
        }

        p {
          font: 20px Poppins-Medium;
          text-overflow: ellipsis;
          white-space: nowrap;
          overflow: hidden;
          margin-top: 20px;
          transition: .3s;

          &:after {
            content: '>';
            position: relative;
            top: 2px;
            margin-left: 20px;
          }
        }

        &:hover {
          p {
            color: @main-c1;
          }
        }

        &:nth-last-child(-n+4) {
          margin-bottom: 0;
        }
      }
    }
  }

  #part3 {
    position: relative;

    .bgcover {
      background: linear-gradient(to bottom, rgba(0, 0, 0, .5), transparent);
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 400px;
      z-index: -1;
    }

    .bgbox {
      background: no-repeat 50% 50%/cover fixed;
      position: absolute;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -2;
    }

    .contentbox {
      margin-top: 285px;

      .tab_header {
        display: flex;
        border-bottom: 1px solid #EAEAEC;
        color: @main-c4;

        .item {
          width: calc(100% / 5);
          border-right: 1px solid #EAEAEC;
          background: @main-c1;
          text-align: center;
          font: 20px Poppins-SemiBold;
          padding: 30px 0;
          cursor: pointer;
          position: relative;
          transition: .3s;

          &:before {
            opacity: 0;
            transition: .3s;
            content: " ";
            top: -7px;
            left: 50%;
            transform: translate(-50%, -50%);
            position: absolute;
            width: 0;
            height: 0;
            color: #fff;
            text-align: center;
            border-bottom: 14px solid white;
            border-left: 7px solid transparent;
            border-right: 7px solid transparent;
            z-index: 1;
          }

          &:after {
            content: '>';
            position: absolute;
            top: 33.5%;
            margin-left: 10px;
            transition: .3s;
          }

          &:hover,
          &.active {
            background: white;
          }

          &.active {
            &:before {
              opacity: 1;
            }

            &:after {
              transform: rotate(90deg);
            }
          }

          &:last-child {
            border: none;
          }
        }
      }

      .tab_content {
        padding: 35px 50px;
        background: white;
        display: flex;
        align-items: center;

        .leftimg {
          margin-right: 70px;
          width: 419px;
          height: 203px;
          object-fit: cover;
        }

        .textbox {
          width: calc(100% - 489px);

          .line {
            display: flex;
            align-items: flex-end;
            margin-bottom: 25px;

            h4 {
              font-size: 26px;
              margin-left: 20px;
            }
          }

          p {
            margin-bottom: 0;
          }
        }
      }
    }
  }

  #part4 {
    background: url("../assets/img/index_part4bg.jpg") no-repeat 50% 50%/cover;
    color: white;

    .mainTitle1 {
      margin-bottom: 30px;

      h3 {
        color: white;
      }
    }

    .contentbox {
      display: flex;
      justify-content: space-between;
      align-items: center;

      .left {
        width: 70%;

        p {
          color: white;
          width: 100%;
          font: 18px/26px Poppins-Regular;
        }

        .mainBtn1 {
          margin-top: 40px
        }
      }

      .right {
        width: 25%;
        border-left: 2px solid #909196;
        display: flex;
        flex-direction: column;
        justify-content: space-between;
        position: relative;

        .item {
          font: 22px Poppins-Medium;
          padding: 30px 0px 30px 50px;
          margin-left: -4px;
          transition: .3s;
          //&.active{border-color: @main-c1;}
        }

        .line {
          position: absolute;
          width: 6px;
          height: 33.333333%;
          background: @main-c1;
          left: -4px;
          animation: moveDown 7s infinite;
        }
      }
    }
  }

  #part5 {
    margin-bottom: 90px;

    .contentbox {
      position: relative;

      .item {
        display: block;

        .imgbox {
          position: relative;
          overflow: hidden;
          background: black;

          .cover {
            position: absolute;
            opacity: 0;
            background: black;
            width: 100%;
            height: 100%;
            left: 0;
            top: 0;
            transition: .6s;
          }

          img {
            width: 100%;
            height: 235px;
            object-fit: cover;
          }

          .triangle-topleft {
            width: 0px;
            height: 0px;
            border-top: 40px solid @main-c1;
            border-right: 40px solid transparent;
            position: absolute;
            top: 0;
            left: -40px;
            transition: .6s;
            z-index: 2;
          }

          .triangle-topright {
            width: 0px;
            height: 0px;
            border-bottom: 40px solid @main-c1;
            border-left: 40px solid transparent;
            position: absolute;
            bottom: 0;
            right: -40px;
            transition: .6s;
            z-index: 2;
          }
        }

        p {
          font: 20px Poppins-Medium;
          padding: 35px 0;
          color: @main-c4;
        }

        .mainBtn2 {
          margin-bottom: 20px;
        }

        &:hover {
          * {
            transition: .6s;
          }

          .imgbox {
            .cover {
              opacity: .2;
            }

            .triangle-topleft {
              left: 0;
            }

            .triangle-topright {
              right: 0;
            }
          }

          .mainBtn2 {
            width: auto;
            padding: 0 15px;
            background: @main-c1;
            border-color: @main-c1;

            span {
              transform: translateX(0%);
              position: relative;
              margin-right: 10px;
              opacity: 1;
            }
          }
        }
      }
    }

    .sbp2 {
      left: -10% !important;
    }

    .sbn2 {
      right: -10% !important;
    }
  }

  .slogan {
    padding: 85px 280px;
    background: @main-c1;
    display: flex;
    align-items: center;
    justify-content: space-between;
    color: @main-c4;

    h2 {
      width: 80%;
    }

    .mainBtn1 {
      border-color: #2A2E43;

      &:hover {
        border-color: @main-c1;
      }
    }
  }

  #part6 {
    margin: 0;
    display: flex;
    justify-content: space-between;
    align-items: center;

    .left {
      width: 45%;
      padding: 110px 0 110px 280px;

      .mainTitle1 {
        h3:before {
          left: -7%;
        }

        p {
          width: 100%;
        }
      }

      .countbox {
        padding: 30px 0 0;
        margin-top: 60px;
        display: none;

        .item {
          margin: 30px 0;

          .num {
            font: 60px Poppins-SemiBold;
            color: @main-c4;
          }

          p {
            font: 16px Poppins-Regular;
            color: #75808B;
          }

          &:nth-child(1) {
            .num:after {
              content: '㎡';
              font-size: 30px;
            }
          }
        }
      }
    }

    .right {
      width: 50%;
    }
  }

  #part7 {
    background: @main-c4;
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: relative;
    z-index: 1;

    .wave3d {
      position: absolute;
      right: 0%;
      top: 0;
      width: 50%;
      height: 100%;
      z-index: -1;
    }

    .left {
      width: 40%;

      .mainTitle1 {
        margin: 0;

        h3:before {
          left: -8%;
        }

        p {
          width: 100%;
          opacity: .6;
        }
      }
    }

    .right {
      width: 60%;
      padding-left: 85px;
      position: relative;

      img {
        width: 216px;
      }

      .swiper-container {
        width: 100%;
      }

      .swiper-slide {
        width: 250px !important;
      }

      .sbp3 {
        left: 0 !important;
      }

      .sbn3 {
        right: -10% !important;
      }
    }

  }

  #part8 {
    .titlebox {
      display: flex;
      justify-content: space-between;
      align-items: center;
      margin-bottom: 70px;

      .mainTitle1 {
        margin-bottom: 0;

        h3:before {
          left: -5.5%;
        }

        p {
          width: 60%;
        }
      }
    }

    .itembox {
      .item {
        background: #F7F8FC;
        width: calc(33% - 17px);

        img {
          width: 100%;
          height: 250px;
        }

        h4 {
          font-size: 20px;
          padding: 25px 35px;
          border-bottom: 2px solid #EAEBEE;
          color: @main-c4;
        }

        .bottom {
          display: flex;
          justify-content: space-between;
          padding: 10px 35px;
          align-items: center;

          span {
            color: @main-c2;
            opacity: .6;
            font: 14px Poppins-Regular;
          }

          i {
            font: 20px Poppins-SemiBold;
            font-style: normal;
            position: relative;
            top: 2px;
            color: @main-c4;
          }
        }

        &:hover {
          .bottom i {
            color: @main-c1;
          }
        }
      }
    }
  }

  #comment {
    background: url("../assets/img/comment_bg.png") no-repeat 100% 0%/40% rgba(247, 248, 252);
    padding: 110px 280px;

    .itembox {
      display: flex;
      position: relative;

      .item {
        display: flex;
        flex-direction: column;
        align-items: center;
        background: white;
        width: calc(33% - 26.66666px);
        padding: 35px;

        .imgbox {
          position: relative;

          .head {
            border-radius: 50%;
            width: 90px;
            height: 90px;
            object-fit: cover;
          }

          .icon {
            position: absolute;
            bottom: -19%;
            right: -35%;
            transform: translate(-50%, -50%);
          }
        }

        .rate {
          margin: 30px 0;

          /deep/ .el-rate__icon {
            font-size: 26px;
          }
        }

        p {
          font: 18px/26px Poppins-Regular;
          color: #657788;
          margin-bottom: 45px;
          text-align: center;
        }

        span {
          font: 18px Poppins-Medium;
          color: @main-c4;
        }
      }
    }
  }
}</style>
<!--transition: transform .3s cubic-bezier(.645,.045,.355,1);transform: translateY(40px);-->